module.exports = __webpack_public_path__ + "static/media/bg.e3e19305.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bg.svg
// module id = 63
// module chunks = 0